import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

export function DefeitoTurmaGrupo({ data, title }) {
    const [items, setItems] = useState([]);
    const [printing, setPrinting] = useState(false);
    const ref = useRef();

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setTimeout(() => {
                    setPrinting(true);
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        },
        pageStyle: `
            @media print {
                .page-break {
                    break-after: always;
                }
            }
        `
    });

    useEffect(() => {
        if (data) {
            let turmas = [];

            data.dados.forEach((item) => {
                if (turmas.indexOf(item.turma) === -1) {
                    turmas.push(item.turma);
                }
            });

            let array = [];

            turmas.forEach((turma) => {
                let object = {};
                object.turma = turma;
                object.total = 0;

                let filtered = data.dados.filter((element) => {
                    return element.turma === turma;
                });

                let colaboradores = [];
                filtered.forEach((element) => {
                    let index = colaboradores.findIndex((colaborador) => {
                        return colaborador.grupo === element.grupo; 
                    });
                    if(index === -1) {
                        colaboradores.push({
                            "nome": element.grupo,
                            "grupo": element.grupo,
                            "total": parseFloat(element.metragem),
                        });

                        object.total += parseFloat(element.metragem);
                    } else {
                        colaboradores[index].total += parseFloat(element.metragem);
                        object.total += parseFloat(element.metragem);
                    }
                });

                object.total = parseInt(object.total);

                object.dados = colaboradores;
                array.push(object);
            });
            setItems(array);
        }
    }, [data]);

    if(items.length === 0) {
        return null;
    }

    return (
        <Panel header={"Metragem por Turma / Colaborador / Grupo - " + title} collapsed toggleable>
            <Button className="p-m-1" icon="pi pi-print" onClick={handlePrint} />
            <div className="p-grid" ref={ref}>
                {items && items.map((items, index) => (
                    <div className={(printing ? "p-col-12" : "p-col-6") + " page-break"} key={index} style={{ height: printing ? "135mm" : "auto" }}>
                        <DataTable
                            className="p-m-1"
                            header={"Turma " + items.turma + " - " + items.total + "m"}
                            size="small"
                            style={{ fontSize: 14 }}
                            value={items.dados}
                        >
                            <Column header="Grupo" field="grupo" sortable style={{ borderWidth: "1px", borderColor: "#000" }} />
                            <Column header="Colaborador" field="nome" style={{ borderWidth: "1px", borderColor: "#000" }} />
                            <Column header="Metros" field="total" style={{ borderWidth: "1px", borderColor: "#000" }} body={(rowData) => (
                                <div>{parseInt(rowData.total)}</div>
                            )} />
                        </DataTable>
                    </div>
                ))}
            </div>
        </Panel>
    )
}